import { createContext, useState, useContext } from "react";

export const NavContext = createContext();

export const useNavContext = ()=>{
    return useContext(NavContext)
}

export const NavProvider = ({ children })=>{
    const [toggle, setToggle] = useState(false);
    

    return (
        <NavContext.Provider value={{toggle, setToggle}}>
            { children }
        </NavContext.Provider>
    )
}